import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const SmsTermsPage = () => {
  useEffect(() => {
    document.title = 'Prestigious Travel Club SMS Terms & Conditions';
  }, []);
  return (
    <div className="min-h-screen bg-white pt-24" data-testid="sms-terms-page">
      <div className="max-w-4xl mx-auto px-6 sm:px-12 lg:px-24 py-12 sm:py-16">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#1E3A8A] mb-4">Legal</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-[#0B1120] tracking-tight mb-12">
          SMS Terms & Conditions
        </h1>

        <div className="prose prose-slate max-w-none space-y-10 text-slate-700 leading-relaxed">

          <section>
            <p>
              Prestigious Travel Club provides transactional text message communications to customers, members,
              applicants, approved business partners, and authorized team members regarding active accounts and
              customer service matters.
            </p>
            <p className="mt-4">Examples of messages include:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Appointment reminders</li>
              <li>Account updates</li>
              <li>Customer support communications</li>
              <li>Membership notifications</li>
              <li>Operational updates</li>
              <li>Service-related notifications</li>
            </ul>
            <p className="mt-4">
              Prestigious Travel Club does <strong>NOT</strong> use this messaging program for unsolicited marketing.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#0B1120] mb-3">Message Frequency</h2>
            <p>
              Message frequency varies depending upon your relationship with Prestigious Travel Club and your
              service activity.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#0B1120] mb-3">Message & Data Rates</h2>
            <p>
              Message and data rates may apply according to your wireless carrier plan.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#0B1120] mb-3">Opt Out</h2>
            <p>You may opt out at any time by replying:</p>
            <p className="my-4">
              <span className="inline-block bg-slate-100 border border-slate-200 rounded-lg px-6 py-3 font-bold text-[#0B1120] text-lg tracking-wide">
                STOP
              </span>
            </p>
            <p>
              After opting out, no additional SMS messages will be sent unless you provide new consent.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#0B1120] mb-3">Help</h2>
            <p>Reply <strong>HELP</strong> for assistance.</p>
            <div className="mt-4">
              <p className="font-semibold text-[#0B1120]">Customer Support</p>
              <p className="mt-2">
                Email:{' '}
                <a href="mailto:support@prestigioustravelclub.org" className="text-[#1E3A8A] underline">
                  support@prestigioustravelclub.org
                </a>
              </p>
              <p className="mt-1">
                Phone:{' '}
                <a href="tel:4077961937" className="text-[#1E3A8A] underline">
                  407-796-1937
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#0B1120] mb-3">Privacy</h2>
            <p>
              For information about how we collect, use, and protect your data, please see our{' '}
              <Link to="/privacy-policy" className="text-[#1E3A8A] underline">Privacy Policy</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#0B1120] mb-3">Mobile Privacy</h2>
            <p>
              Mobile information will not be shared, sold, rented, or used for marketing purposes without
              the customer's consent except as required by law.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default SmsTermsPage;
